import React, { useState, useMemo, useEffect } from 'react';
import ProductCard from './ProductCard';

// The storefront landing: a sticky category tab row + a responsive product
// grid. "Featured" shows the whole catalogue; the rest filter by category.

const ProductShopGrid = ({ products, categories, currency, loading, onOpen, onAdd }) => {
  const [tab, setTab] = useState('Featured');

  // If categories change (data load) and the active tab vanished, reset.
  useEffect(() => {
    if (!categories.includes(tab)) setTab('Featured');
  }, [categories, tab]);

  const shown = useMemo(
    () => (tab === 'Featured' ? products : products.filter((p) => p.category === tab)),
    [products, tab],
  );

  return (
    <div className="ps-shop">
      <div className="ps-tabs" role="tablist" aria-label="Product categories">
        {categories.map((c) => (
          <button
            key={c}
            type="button"
            role="tab"
            aria-selected={tab === c}
            className={`ps-tab ${tab === c ? 'is-active' : ''}`}
            onClick={() => setTab(c)}
          >
            {c}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="ps-grid">
          {Array.from({ length: 6 }).map((_, i) => <div key={i} className="ps-card ps-card--skeleton" aria-hidden />)}
        </div>
      ) : shown.length === 0 ? (
        <div className="ps-empty">
          <p className="ps-empty-title">Nothing here yet</p>
          <p className="ps-empty-sub">No products in this category right now.</p>
        </div>
      ) : (
        <div className="ps-grid">
          {shown.map((p) => (
            <ProductCard key={p.id} product={p} currency={currency} onOpen={onOpen} onAdd={onAdd} />
          ))}
        </div>
      )}
    </div>
  );
};

export default ProductShopGrid;
